"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const giftbrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-giftbrand03` : '') + (description ? ` desc-giftbrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-giftbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-giftbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M67.535 22.605C70 22.605 72 24.604 72 27.07v6.697C72 35 71 36 69.767 36h-2.79v31.5c0 2.485-1.99 4.5-4.444 4.5h-48.88c-2.454 0-4.444-2.015-4.444-4.5V36H7.256c-1.233 0-2.233-1-2.233-2.233V27.07c0-2.466 2-4.465 4.465-4.465h58.047ZM15.907 5.023C25.772 5.023 36 12.893 36 22.605c-9.865 0-20.093-7.871-20.093-17.582Zm45.21 0-.004.291c-.201 9.577-10.324 17.29-20.09 17.29l.003-.29c.202-9.577 10.324-17.29 20.09-17.29Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.302 32.093a1 1 0 0 1 1-1H63.35a1 1 0 0 1 1 1v31.256a5.465 5.465 0 0 1-5.465 5.465H9.767a5.465 5.465 0 0 1-5.465-5.465V32.093Zm2 1v30.256a3.465 3.465 0 0 0 3.465 3.465h49.117a3.465 3.465 0 0 0 3.465-3.465V33.093H6.302Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M-.163 23.163a5.465 5.465 0 0 1 5.465-5.465H63.35a5.465 5.465 0 0 1 5.465 5.465v6.697a3.233 3.233 0 0 1-3.233 3.233H3.07A3.233 3.233 0 0 1-.163 29.86v-6.697Zm5.465-3.465a3.465 3.465 0 0 0-3.465 3.465v6.697c0 .681.552 1.233 1.233 1.233H65.58c.681 0 1.233-.552 1.233-1.233v-6.697a3.465 3.465 0 0 0-3.465-3.465H5.302Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12-.163a1 1 0 0 1 1 1c0 4.573 2.373 8.779 5.996 11.869 3.625 3.091 8.423 4.992 13.097 4.992a1 1 0 1 1 0 2c-5.19 0-10.44-2.098-14.395-5.47C13.742 10.854 11 6.129 11 .838a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 .837a1 1 0 0 1 1-1c5.19 0 10.44 2.098 14.395 5.47 3.956 3.374 6.698 8.099 6.698 13.39a1 1 0 1 1-2 0c0-4.572-2.372-8.778-5.996-11.868C21.472 3.738 16.674 1.837 12 1.837a1 1 0 0 1-1-1ZM56.651-.163a1 1 0 0 1 1 1c0 5.292-2.741 10.017-6.698 13.39-3.955 3.373-9.204 5.47-14.395 5.47a1 1 0 1 1 0-2c4.674 0 9.472-1.9 13.097-4.991C53.28 9.616 55.651 5.41 55.651.837a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.257 5.307C46.21 1.935 51.46-.163 56.65-.163a1 1 0 1 1 0 2c-4.674 0-9.472 1.9-13.097 4.992-3.623 3.09-5.996 7.296-5.996 11.869a1 1 0 1 1-2 0c0-5.292 2.742-10.017 6.699-13.39Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.628 18.698a1 1 0 0 1 1-1h13.395a1 1 0 0 1 1 1v49.116a1 1 0 0 1-1 1H27.628a1 1 0 0 1-1-1V18.698Zm2 1v47.116h11.395V19.698H28.628Z"
  }))));
};
var _default = exports.default = giftbrand03;